// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-fountain-js": () => import("./../../../src/pages/fountain.js" /* webpackChunkName: "component---src-pages-fountain-js" */),
  "component---src-pages-index-amp-js": () => import("./../../../src/pages/index.amp.js" /* webpackChunkName: "component---src-pages-index-amp-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

